import React from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import {Message} from '@aperza/ui';
import FormRow from '../form/FormRow'
import FormHorizonalField from './FormHorizonalField';
import FormField from '../form/FormField';
import FormBusinessTypeField from './FormBusinessTypeField';
import FormJobCategoryTypeField from './FormJobCategoryTypeField'
import FormSubdivisionField from './FormSubdivisionField';
import {Constraint} from '@aperza/validator';
import {createRefetchContainer, graphql} from "react-relay";
import FormFieldUtil from "../../util/FormFieldUtil";

class CustomerInfoForm extends React.Component {

  static propTypes = {
    viewer: PropTypes.any,
    readOnly: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    let prevUser = prevProps.viewer.user;
    let newUser = this.props.viewer.user;

    if (JSON.stringify(prevUser) !== JSON.stringify(newUser) ) {
        this.setState({
          fields: this.createUserFieldArray(newUser)
        })
    }
  }

  componentDidMount() {
    this.refetch();
  }

  refetch() {
    this.setState({ loading: true });
    this.props.relay.refetch(
      {},
      null,  // We can use the refetchVariables as renderVariables
      (error) => {
        this.setState({ loading: false });
      },
      { force: false }  // Assuming we've configured a network layer cache, we want to ensure we fetch the latest data.
    );
  }

  constructor(props) {
    super(props);
    let user = props.viewer.user;
    // let user = {
    //   firstName: '',
    //   lastName: '',
    //   phoneNumber: '',
    //   companyName: '',
    //   officeName:'',
    //   departmentName: '',
    //   businessType:'',
    //   jobCategoryType: '',
    //   subdivisionCode: ''
    // };

    this.state = {
      businessTypeName: user.businessType?user.businessType:undefined,
      fields: this.createUserFieldArray(user)
    }
  }

  createUserFieldArray(user) {
    return [
          {
            fieldName: 'first_name',
            constraint: Constraint.firstName,
            value: user.firstName?user.firstName:'',
          },
          {
            fieldName: 'last_name',
            constraint: Constraint.lastName,
            value: user.lastName?user.lastName:'',
          },
          {
            fieldName: 'phone_number',
            constraint: Constraint.phoneNumber,
            value: user.phoneNumber?user.phoneNumber:'',
          },
          {
            fieldName: 'company_name',
            constraint: Constraint.companyName,
            value: user.companyName?user.companyName:'',
          },
          {
            fieldName: 'office_name',
            constraint: Constraint.officeName,
            value: user.officeName?user.officeName:'',
          },
          {
            fieldName: 'department',
            constraint: Constraint.departmentName,
            value: user.departmentName?user.departmentName:'',
          },
          {
            fieldName: 'business_types',
            constraint: Constraint.businessType,
            value: user.businessType?user.businessType:'',
          },
          {
            fieldName: 'job_category_types',
            constraint: Constraint.jobCategoryType,
            value: user.jobCategoryType?user.jobCategoryType:'',
          },
          {
            fieldName: 'subdivision_code',
            constraint: Constraint.subdivisionCode,
            value: user.subdivisionCode?user.subdivisionCode:'',
          },
        ]
  }

  onBusinessTypeChange(value) {
    console.log('onBusinessTypeChange', value);
    this.setState({businessTypeName: value});
  }

  onBlur(fieldName, value) {
    this.doValidateFieldByFieldName(fieldName, value);
  }

  onChange(fieldName, value) {
    this.doValidateFieldByFieldName(fieldName, value);
  }

  validate() {
    let updatedFields = FormFieldUtil.validateFields(this.state.fields);
    if (updatedFields) {
      this.setState({fields:updatedFields});
      return updatedFields;
    }
    return undefined;
  }

  doValidateFieldByFieldName(fieldName, value) {
    let fields = FormFieldUtil.validateFieldByFieldName(this.state.fields, fieldName, value);
    this.setState({
      fields,
      businessTypeName: fieldName==='business_types'?value:this.state.businessTypeName,
    });
  }

  render() {
    let fieldMap = FormFieldUtil.convertFieldsToMap(this.state.fields);

    let {
      readOnly
    } = this.props;

    return (
      <Container fluid="true" className="aw-form mb-5" id="customerInfoForm">
        <h4 className="font-weight-bold text-primary"><Message messageId="customerInfo" /></h4>
        <FormRow rowNameId={'last_name'} required={true}>
          <FormField
            readOnly={readOnly}
            fieldName={'last_name'}
            placeholderId={'ex_last_name'}
            {...fieldMap['last_name']}
            onBlur={::this.onBlur}
            onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'first_name'} required={true}>
          <FormField
            readOnly={readOnly}
            fieldName={'first_name'}
            placeholderId={'ex_first_name'}
            {...fieldMap['first_name']}
            onBlur={::this.onBlur}
            onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'phone_number'} required={true}>
          <FormField
            readOnly={readOnly}
            remarkId={'phone_number_valid'}
            fieldName={'phone_number'}
            placeholderId={'ex_phone_number'}
            {...fieldMap['phone_number']}
            onBlur={::this.onBlur}
            onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'companyName'} required={true}>
          <FormField
            readOnly={readOnly}
            fieldName={'company_name'}
            placeholderId={'ex_company_name'}
            {...fieldMap['company_name']}
            onBlur={::this.onBlur}
            onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'officeName'}>
          <FormField
            readOnly={readOnly}
            fieldName={'office_name'}
            placeholderId={'ex_office_name'}
            {...fieldMap['office_name']}
            onBlur={::this.onBlur}
            onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'department'} required={true}>
          <FormField
            readOnly={readOnly}
            fieldName={'department'}
            // remarkId={'department_valid'}
            placeholderId={'ex_department'}
            {...fieldMap['department']}
            onBlur={::this.onBlur}
            onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'businessTypes'} required={true}>
          <FormBusinessTypeField viewer={this.props.viewer}
                                 readOnly={readOnly}
                                 {...fieldMap['business_types']}
                                 onBlur={::this.onBlur}
                                 onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'jobCategoryTypes'} required={true}>
          <FormJobCategoryTypeField viewer={this.props.viewer}
                                    readOnly={readOnly}
                                    businessTypeName={this.state.businessTypeName}
                                    {...fieldMap['job_category_types']}
                                    onBlur={::this.onBlur}
                                    onChange={::this.onChange} />
        </FormRow>
        <FormRow rowNameId={'subdivisionCode'} required={true}>
          <FormSubdivisionField viewer={this.props.viewer}
                                readOnly={readOnly}
                                {...fieldMap['subdivision_code']}
                                onBlur={::this.onBlur}
                                onChange={::this.onChange} />
        </FormRow>
      </Container>

    )
  }

}

export default createRefetchContainer(
  CustomerInfoForm,
  {
    viewer: graphql`
        fragment CustomerInfoForm_viewer on Viewer {
            user {
                firstName
                lastName
                phoneNumber
                companyName
                officeName
                departmentName
                businessType
                jobCategoryType
                subdivisionCode
            }
            ...FormBusinessTypeField_viewer
            ...FormSubdivisionField_viewer
            ...FormJobCategoryTypeField_viewer
        }
    `
  },
    graphql`
          query CustomerInfoFormRefetchQuery {
              viewer {
                  ...CustomerInfoForm_viewer
              }
          }
    `
);
